import { SectionHeader, LegacyDataTable, LegacyDataTableBody, LegacyDataTableRow, LegacyDataTableRowColumn, LegacyDataTableRowHeaderColumn } from "@octopusdeploy/design-system-components";
import type { ServerDocumentCounts } from "@octopusdeploy/octopus-server-client";
import { startCase } from "lodash";
import Section from "~/components/Section";
interface ServerDocumentCountsProps {
    documentCounts: ServerDocumentCounts;
}
export default function ServerDocumentCountsTable(props: ServerDocumentCountsProps) {
    return (<Section sectionHeader="System-wide document counts">
            {Object.entries(props.documentCounts).map(([group, documentCounts]) => {
            return (<div key={group}>
                        <SectionHeader title={group}/>
                        <LegacyDataTable>
                            <LegacyDataTableBody>
                                {Object.entries(documentCounts).map(([documentType, count]) => {
                    return (<LegacyDataTableRow key={documentType}>
                                            <LegacyDataTableRowHeaderColumn>{startCase(documentType)}</LegacyDataTableRowHeaderColumn>
                                            <LegacyDataTableRowColumn>{count}</LegacyDataTableRowColumn>
                                        </LegacyDataTableRow>);
                })}
                            </LegacyDataTableBody>
                        </LegacyDataTable>
                    </div>);
        })}
        </Section>);
}
ServerDocumentCountsTable.displayName = "System-wide document counts";
